//import addLicenseDialog from '../components/dialogs/AddLicenseDialog.vue'
//import ManDevicesInLicenseModule from '../components/dialogs/ManDevicesInLicenseModule.vue'
import Navigation from "../components/utils/Navigation.vue";
import NoDataAvailable from "../components/utils/NoDataAvailable.vue";
import { PC_MESSAGES } from '../utils/messages';
import PCLicenseLink from '../components/utils/PCLicenseLink.vue';
import { iconsToModuleEnabled, iconsToModuleDisabled } from "../utils/objects.js";
const qs = require('querystring')

export default {
    name: "Licenses",
    metaInfo: {
        // if no subcomponents specify a metaInfo.title, this title will be used
        title: 'Licenses',
        // all titles will be injected into this template
        titleTemplate: '%s | Iperius One '
    },
    data() {
        return {
            tipo: '',
            computersinlic: {},
            moduleExtDescription: '',
            currLicId: 0,
            currNode: '',
            currModuleIndex: 0,
            loader: false,
            licenses: {},
            searchText: '',
			selectedComputerId: null,
			assigningComputer: false,
            licenseDetails: null, // Dettagli licenza singola,
            pricing: null,
            currentLicenseLogin: {},
            companyName: '',
            initialCompanyName: '',
            savingCompany: false,
            license: {
                num_users: 1,
                num_workstations: 0,
                num_servers: 0,
                num_vms: 0,
                plugin_exchange: 0,
                plugin_database: 0,
                plugin_tape: 0,
                subscription_duration: 1,
                discount_code: null,
                currency: 'EUR'
            },
        }
    },
    props: {},
    mounted: function () {
        this.licenses = this.$session.getLicenses();
        this.licenseDetails = this.$session.getLicense();
        this.roles = this.$api.getRoles();

        this.currentLicenseLogin = this.$root.authObj;
        this.companyName = this.currentLicenseLogin.company || '';
        this.initialCompanyName = this.companyName;

        this.$root.refreshEcommerceUpgradeUrl();

    },
    computed: {
        companyChanged() {
            return this.companyName !== this.initialCompanyName;
        },
        filteredComputers() {
            if (!this.computersinlic?.computers) return [];

            return this.computersinlic.computers.filter(comp => {
                const txt = this.searchText.toLowerCase();
                return (
					String(comp.name || comp.pc_name || '').toLowerCase().includes(txt) ||
					String(comp.custom_name || '').toLowerCase().includes(txt) ||
					String(comp.organization_name || '').toLowerCase().includes(txt)
                );
            });
		},
		hasAvailableSlots() {
			return Number(this.computersinlic?.used_slots || 0) < Number(this.computersinlic?.total_slots || 0);
		},
		availableComputers() {
			const assignedIds = new Set((this.computersinlic?.computers || []).map(computer => String(computer.id)));
			return (this.$session.getPCList() || []).filter(computer =>
				Number(computer.backup_license_status) === 1 && !assignedIds.has(String(computer.id))
			);
        }
    },
    created: function () {

    },
    components: {
        Navigation,
        NoDataAvailable,
        PCLicenseLink,
        //ManDevicesInLicenseModule,
    },
    methods: {
        async saveCompany() {
            if (!this.companyChanged || this.savingCompany) return;

            this.savingCompany = true;
            try {
                const saved = await this.$api.updateMasterAccountCompany(this.companyName);
                if (!saved) return;

                this.initialCompanyName = this.companyName;
                this.currentLicenseLogin.company = this.companyName;
                this.$root.authObj.company = this.companyName;
                this.$session.setAuth(this.$root.authObj);
                localStorage.setItem("AUTH", JSON.stringify(this.$root.authObj));
                this.$root.toast(this.$t("Company updated successfully."), "success");
            } finally {
                this.savingCompany = false;
            }
        },

        getFeatureIconClass: function (status, feature_id) {
            if (status == 'on') {
                return iconsToModuleEnabled[feature_id] || '/assets/img/icons/license_icons/folder_black.svg'; // default icona
            }
            else {
                return iconsToModuleDisabled[feature_id] || '/assets/img/icons/license_icons/folder_black.svg'; // dafault icona
            }
        },

        goBack() {
            window.history.length > 1 ? this.$router.go(-1) : this.$router.replace('/')
            this.loader = false;
        },
        getName() {
            return this.auth = this.$root.authObj.firstName + " " + this.$root.authObj.lastName;
        },

        updateLicense() {
            this.licenses = this.$session.getLicenses();
        },

        async getRoles() {
            let self = this;
            var roles = await this.$api.getRoles();
            self.$store.commit('SET_ROLES', roles);
        },

        toggleDeviceInModule(node, index, licObj) {
            this.moduleExtDescription = licObj.description + ' (' + licObj.nome_licenza + ')';
            this.currLicId = licObj.id;
            this.currNode = node;
            this.currModuleIndex = index;
			this.selectedComputerId = null;
			this.searchText = '';

            if (node === 'backup') {
                this.computersinlic = this.licenses.backup[index];
                //this.$set(this, 'computersinlic', [...this.licenses.backup[index].computers]); // Notifica Vue
            }

            if (node === 'monitoring') {
                this.computersinlic = this.licenses.monitoring[index];
                //this.$set(this, 'computersinlic', [...this.licenses.monitoring[index].computers]);
            }

            window.Metro.charms.toggle('#mandevicesinlicensemodule');
        },

		computerDisplayName(computer) {
			const name = computer.pc_name || computer.name || computer.id;
			return computer.organization_name ? `${name} (${computer.organization_name})` : name;
		},

		licenseStatusLabel(status) {
			return {
				0: "Not linked to an Iperius One license",
				1: "Connected to the license",
				2: "Waiting to restart agent",
				3: "Removed from the license",
				4: "Banned from the license"
			}[status] || "Unknown";
		},

		licenseStatusClass(status) {
			return {
				0: "bg-gray fg-white",
				1: "bg-green fg-white",
				2: "bg-orange fg-white",
				3: "bg-red fg-white",
				4: "bg-darkRed fg-white"
			}[status] || "bg-gray fg-white";
		},

		async reloadLicenseInformation(assignedComputer = null, minimumUsedSlots = 0) {
			const [extendedLicenses, computers] = await Promise.all([
				this.$api.getLicenseExtendedInfo(),
				this.$api.getPCListUltraLite()
			]);

			if (Array.isArray(computers)) {
				this.$session.setPCList(computers);
			}
			if (extendedLicenses == null) return;

			const refreshedModule = (extendedLicenses[this.currNode] || []).find(license => license.id == this.currLicId);
			if (refreshedModule && assignedComputer) {
				const refreshedPC = (computers || []).find(item => item.id == assignedComputer.id);
				const computerToDisplay = {
					...assignedComputer,
					...(refreshedPC || {}),
					name: (refreshedPC && (refreshedPC.name || refreshedPC.pc_name)) || assignedComputer.name
				};
				const refreshedComputers = [...(refreshedModule.computers || [])];
				const computerIndex = refreshedComputers.findIndex(item => item.id == computerToDisplay.id);
				if (computerIndex === -1) refreshedComputers.push(computerToDisplay);
				else refreshedComputers[computerIndex] = { ...refreshedComputers[computerIndex], ...computerToDisplay };
				refreshedModule.computers = refreshedComputers;
				refreshedModule.used_slots = Math.max(Number(refreshedModule.used_slots || 0), minimumUsedSlots);
			}

			this.licenses = extendedLicenses;
			this.computersinlic = refreshedModule || this.computersinlic;
			this.$session.setLicenses(extendedLicenses);
		},

		assignComputerToModule() {
			if (!this.hasAvailableSlots || this.selectedComputerId == null || this.assigningComputer) return;

			const computer = this.availableComputers.find(item => item.id == this.selectedComputerId);
			if (!computer) return;

			const dialogID = Math.floor(100000 + Math.random() * 900000).toString();
			this.$root.$once(dialogID, async confirmed => {
				if (!confirmed || !this.hasAvailableSlots) return;
				this.assigningComputer = true;
				try {
					const associated = await this.$api.associateComputerToModule(computer.id, this.currLicId);
					if (!associated) return;

					const assignedComputer = {
						...computer,
						name: computer.name || computer.pc_name || String(computer.id),
						custom_name: computer.custom_name || '',
						organization_name: computer.organization_name || ''
					};
					const usedSlotsAfterAssignment = Number(this.computersinlic.used_slots || 0) + 1;
					const assignedComputers = [...(this.computersinlic.computers || [])];
					if (!assignedComputers.some(item => item.id == assignedComputer.id)) {
						assignedComputers.push(assignedComputer);
					}
					this.$set(this.computersinlic, 'computers', assignedComputers);
					this.$set(this.computersinlic, 'used_slots', usedSlotsAfterAssignment);
					this.selectedComputerId = null;
					this.$root.toast(this.$t(PC_MESSAGES.ADD_TO_MODULE), "success");

					await this.reloadLicenseInformation(assignedComputer, usedSlotsAfterAssignment);
				} finally {
					this.assigningComputer = false;
				}
			});
			this.$root.openYesNoDialog(
				dialogID,
				this.$t("Add computer to the license module"),
				this.$t("associate_computer_to_module", {
					0: this.computerDisplayName(computer),
					1: this.computersinlic.nome_licenza
				})
			);
		},


        closeCharms() {
            window.Metro.charms.close('#mandevicesinlicensemodule');
        },

        remotePcFromLicenseModule(pc) {
            //PUT "api/licenses/features/enable"
            //PUT "api/licenses/features/disable"

            //per entrambe nel body ci vuole:
            //idc : id computer
            //idf : id_feature


            // 1 fare chiamata API    
            // 2 refresh LICENSES in session
            // 3 aggiornare oggetto per charms

            var dialogID = Math.floor(100000 + Math.random() * 900000).toString();
            let self = this;


            this.$root.$on(dialogID, async ok => {
                try {
                    if (!ok) {
                        return;
                    }

                    self.$api.removeComputerFromModule(pc.id, self.currLicId).then(async (value) => {
                        if (value) {
                            self.$root.toast(this.$t(PC_MESSAGES.REMOVE_FROM_MODULE), "success")

                            this.computersinlic.computers = this.computersinlic.computers.filter(computer => computer.id !== pc.id);

                            let ext_lic_info = await self.$api.getLicenseExtendedInfo();

                            if (ext_lic_info != null) {
                                this.$session.setLicenses(ext_lic_info);
                                this.licenses = this.$session.getLicenses();
                            };

                        }

                    });


                } finally {
                    //self.$router.removeHash(); // prototype implementato in main.js
                    self.$root.$off(dialogID);
                }
                return;

            });

            this.$root.openYesNoDialog(dialogID, this.$t("Remove computer from the license module"), this.$t("Are you sure you want to remove " + pc.name + " (" + pc.custom_name + ") from module " + this.moduleExtDescription + " ?"));
        },

    }
};
